/**
 * File slideshow.js.
 *
 * variable-width slideshow.
 *
 * @package wildrivers
 */

import 'slick-slider';

function get$() {
	return typeof window.jQuery !== 'undefined' ? window.jQuery : null;
}
		
function initSlick( container ) {
	const $ = get$();
	if (!$ || !container || $(container).hasClass('slick-initialized')) return;

	$(container).slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		adaptiveHeight: false,
		dots: false,
		arrows: true,
		infinite: true,
		centerMode: true,
		autoplay: false,
		variableWidth: true,
		speed: 300,
		centerPadding: '30px',
	});


	adjustCaptionWidth();
	window.addEventListener( "resize", adjustCaptionWidth );
	
	function adjustCaptionWidth() {
		const imageSlides = container.querySelectorAll('.slideshow--slide');
		if ( !imageSlides?.length ) {
			return;
		}
		imageSlides.forEach( (slide) => {
			const caption = slide.querySelector( '.slideshow--caption' );
			const image = slide.querySelector( '.slideshow--image > img' );

			if ( caption ) {
				caption.setAttribute( 'style', 'width: ' + image.getBoundingClientRect().width + 'px' );
			}
		});
	};
}

export function slideshow() {
	const slideSets = document.querySelectorAll('.slideshow--slides');
	if (!slideSets?.length) {
		return;
	}

	slideSets.forEach( (slideSet) => {
		initSlick( slideSet );
	});
}
